export default {
    TOP_BAR_HEIGHT: 72,
    EDIT_SEGMENT_BAR_HEIGHT: 72
};
